var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { attrs: { "aria-label": "Login" } },
    [
      _c("slide-in-overlay", {
        staticClass: "c-map",
        attrs: { "is-open": _vm.isOpen },
        on: { close: _vm.close },
        scopedSlots: _vm._u(
          [
            {
              key: "heading",
              fn: function() {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.translations["Find store"]) +
                      "\n        "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function() {
                return [
                  _c("img", {
                    attrs: {
                      alt: "Minifabrikken lokation",
                      src: "/images/map.jpg"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "c-map__adress" },
                    [_vm._t("address")],
                    2
                  )
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  _c("div", { staticClass: "c-map__buttons" }, [
                    _c(
                      "a",
                      {
                        staticClass: "o-btn o-btn--fullwidth",
                        attrs: {
                          rel: "noopener",
                          href: _vm.link,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.translations["Show the way"]))]
                    )
                  ])
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }